module.exports = __webpack_public_path__ + "img/ic_village_product3.e8e06617.png";